import { render, staticRenderFns } from "./NewTask.vue?vue&type=template&id=02f53484&scoped=true&"
import script from "./NewTask.vue?vue&type=script&lang=js&"
export * from "./NewTask.vue?vue&type=script&lang=js&"
import style0 from "@fortawesome/fontawesome-free-webfonts/css/fa-solid.css?vue&type=style&index=0&id=02f53484&lang=css&scoped=true&"
import style1 from "@fortawesome/fontawesome-free-webfonts/css/fontawesome.css?vue&type=style&index=1&id=02f53484&lang=css&scoped=true&"
import style2 from "@/styles/option.css?vue&type=style&index=2&id=02f53484&lang=css&scoped=true&"
import style3 from "./NewTask.vue?vue&type=style&index=3&id=02f53484&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f53484",
  null
  
)

export default component.exports